import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Plus, Trash2, Tag } from "lucide-react";
import { toast } from "sonner";

export default function Categories() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const load = () => api.get("/categories").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post("/categories", { name: name.trim() });
      toast.success("Category added");
      setName(""); load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
  };
  const del = async (id) => { if (!window.confirm("Delete category?")) return; await api.delete(`/categories/${id}`); load(); };

  return (
    <div className="p-6 md:p-10 max-w-3xl mx-auto" data-testid="categories-root">
      <h1 className="font-display font-bold text-3xl mb-6">Categories</h1>
      <form onSubmit={add} className="card-soft p-4 flex gap-3 mb-5">
        <input data-testid="cat-name-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="New category e.g. Kanjeevaram Saree" className="h-12 flex-1 px-3 rounded-md border bg-white" style={{ borderColor: "var(--border-soft)" }} />
        <button data-testid="cat-add-btn" className="h-12 px-5 rounded-md text-white font-semibold tactile-btn inline-flex items-center gap-2" style={{ background: "var(--primary)" }}><Plus size={16} /> Add</button>
      </form>
      <div className="card-soft divide-y" style={{ borderColor: "var(--border-soft)" }}>
        {items.length === 0 && <div className="p-8 text-center text-sm" style={{ color: "var(--text-muted)" }}>No categories yet.</div>}
        {items.map((c) => (
          <div key={c.id} className="flex items-center gap-3 p-3" data-testid={`cat-row-${c.id}`}>
            <div className="w-9 h-9 rounded-md grid place-items-center" style={{ background: "var(--surface-tint)", color: "var(--primary)" }}><Tag size={16} /></div>
            <div className="flex-1 font-medium">{c.name}</div>
            <button data-testid={`cat-del-${c.id}`} onClick={() => del(c.id)} style={{ color: "var(--error)" }}><Trash2 size={16} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
